import cloneDeep from 'lodash/cloneDeep';

class EmailPreferences {
  constructor({
    id, customerid, dealerid, algaeInSpa, metalStaining, algaeBlack, otherStaining, algaeGreen, scale,
    algaeMustard, slimeMold, chlorineDemand, swampy, cloudyOrHazyWater, waterlineBuildup, foaming,
    winterProductReminder, poolClosingReminder, memorialDayReminder, fourthOfJulyReminder, labourDayReminder,
    newCustomerWelcome, existingCustomerWelcome, pastDue, inactiveCustomer, poolOpeningReminder, victoriaDayReminder,
    canadaDayReminder,
  }) {
    this.id = id;
    this.customerid = customerid;
    this.dealerid = dealerid;

    this.algaeInSpa = algaeInSpa;
    this.metalStaining = metalStaining;
    this.algaeBlack = algaeBlack;
    this.otherStaining = otherStaining;
    this.algaeGreen = algaeGreen;
    this.scale = scale;
    this.algaeMustard = algaeMustard;
    this.slimeMold = slimeMold;
    this.chlorineDemand = chlorineDemand;
    this.swampy = swampy;
    this.cloudyOrHazyWater = cloudyOrHazyWater;
    this.waterlineBuildup = waterlineBuildup;
    this.foaming = foaming;

    this.winterProductReminder = winterProductReminder;
    this.poolClosingReminder = poolClosingReminder;
    this.memorialDayReminder = memorialDayReminder;
    this.fourthOfJulyReminder = fourthOfJulyReminder;
    this.labourDayReminder = labourDayReminder;

    this.newCustomerWelcome = newCustomerWelcome;
    this.existingCustomerWelcome = existingCustomerWelcome;
    this.pastDue = pastDue;
    this.inactiveCustomer = inactiveCustomer;
    this.poolOpeningReminder = poolOpeningReminder;
    this.canadaDayReminder = canadaDayReminder;
    this.victoriaDayReminder = victoriaDayReminder;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      CustomerID: this.customerid,
      DealerID: this.dealerid,

      AlgaeInSpa: this.algaeInSpa,
      MetalStaining: this.metalStaining,
      AlgaeBlack: this.algaeBlack,
      OtherStaining: this.otherStaining,
      AlgaeGreen: this.algaeGreen,
      Scale: this.scale,
      AlgaeMustard: this.algaeMustard,
      SlimeMold: this.slimeMold,
      ChlorineDemand: this.chlorineDemand,
      Swampy: this.swampy,
      CloudyOrHazyWater: this.cloudyOrHazyWater,
      WaterlineBuildup: this.waterlineBuildup,
      Foaming: this.foaming,

      WinterProductReminder: this.winterProductReminder,
      PoolClosingReminder: this.poolClosingReminder,
      MemorialDayReminder: this.memorialDayReminder,
      FourthOfJulyReminder: this.fourthOfJulyReminder,
      LabourDayReminder: this.labourDayReminder,

      NewCustomerWelcome: this.newCustomerWelcome,
      ExistingCustomerWelcome: this.existingCustomerWelcome,
      PastDue: this.pastDue,
      InactiveCustomer: this.inactiveCustomer,
      PoolOpeningReminder: this.poolOpeningReminder,
      VictoriaDayReminder: this.victoriaDayReminder,
      CanadaDayReminder: this.canadaDayReminder,
    };
  }

  static fromApiFormat(api) {
    return new EmailPreferences({
      id: api.ID,
      customerid: api.CustomerID,
      dealerid: api.DealerID,

      algaeInSpa: api.AlgaeInSpa,
      metalStaining: api.MetalStaining,
      algaeBlack: api.AlgaeBlack,
      otherStaining: api.OtherStaining,
      algaeGreen: api.AlgaeGreen,
      scale: api.Scale,
      algaeMustard: api.AlgaeMustard,
      slimeMold: api.SlimeMold,
      chlorineDemand: api.ChlorineDemand,
      swampy: api.Swampy,
      cloudyOrHazyWater: api.CloudyOrHazyWater,
      waterlineBuildup: api.WaterlineBuildup,
      foaming: api.Foaming,

      winterProductReminder: api.WinterProductReminder,
      poolClosingReminder: api.PoolClosingReminder,
      memorialDayReminder: api.MemorialDayReminder,
      fourthOfJulyReminder: api.FourthOfJulyReminder,
      labourDayReminder: api.LabourDayReminder,

      newCustomerWelcome: api.NewCustomerWelcome,
      existingCustomerWelcome: api.ExistingCustomerWelcome,
      pastDue: api.PastDue,
      inactiveCustomer: api.InactiveCustomer,
      poolOpeningReminder: api.PoolOpeningReminder,
      canadaDayReminder: api.CanadaDayReminder,
      victoriaDayReminder: api.VictoriaDayReminder,
    });
  }
}

export default EmailPreferences;
